if (!customElements.get('free-gift')) {
    customElements.define(
      'free-gift',
      class FreeGift extends HTMLElement {
        constructor() {
          super();

          let giftBtn = document.querySelectorAll('.js-gift-popup-btn');
          giftBtn.forEach(button => {
            button.addEventListener('click', this.showPopUpContent.bind(this));
          });

          this.colorOptions = this.querySelectorAll('.js-color-option');
          if(this.colorOptions.length > 0){
            this.colorOptions.forEach((option, index) => {
              if(index == 0) option.classList.add('selected');
              option.addEventListener('click', this.changeColor.bind(this, option));
            })
          }

          let giftDataElement = this.querySelector('.js-free-gift-content');
          if (giftDataElement) {
            this.products = JSON.parse(giftDataElement.textContent).products;
          }

          this.addToCartBtn = this.querySelector('.js-free-gift-add-btn');
          if(this.addToCartBtn) this.addToCartBtn.addEventListener('click', this.handleSubmit.bind(this));
        }
  
        showPopUpContent() {
          $s.openModal(this);
        }

        changeColor(option) {
          this.colorOptions.forEach(button => button.classList.remove('selected'));
          option.classList.add('selected');

          const selectedVariant = this.querySelector('.js-selected-variant');
          const selectedOption = option.getAttribute('data-variant-title');
          if (selectedVariant && selectedOption) {
              selectedVariant.innerHTML = selectedOption;
          }

          const productIndex = option.getAttribute('data-product-index');
          const product = this.products[parseInt(productIndex, 10)];
          if (product) {
              let productImage = this.querySelector('.js-free-gift-image img');
              let productTitle = this.querySelector('.js-free-gift-title');

              if (productImage) productImage.src = product.featuredMedia;
              if (productTitle) productTitle.innerHTML = product.name;
          }

          let dropdown = this.querySelector('.js-variant-dropdown');
          if(dropdown) dropdown.removeAttribute('open');

          let variantId = product.colors[0].variantId;
          console.log("variantId", variantId)

          if(this.addToCartBtn) this.addToCartBtn.setAttribute('data-variant-id', variantId);
        }

        handleSubmit() {
          let variantId = this.addToCartBtn.getAttribute('data-variant-id');
          let formData = {
            'items': [{
              'id': parseInt(variantId, 10),
              'quantity': 1,
              'properties': {
              '_is_gift_product': true
              }
            }]
          };

          $s.closeModal();
          $s.showLoadingOverlay();
          
          $s.post({
            type: 'POST',
            url: '/cart/add.js',
            data: formData,
            dataType: 'json',
            success: async function(cart) {
              window.CartPage.updateCart();
              $s.hideLoadingOverlay();
            },
            error: $s.addToCartFail
          });
        }

      }
    );
  }
  